import React from "react";

export const FestivalCategory = ({category}) => (
  <>
      <span
          css={`
            font-family: 'Barlow Condensed', sans-serif;
            font-weight: 500;
            color: ${props => props.theme.colors.accent1._100};
          `}
      >{category}</span>
      <span
          css={`
            width: 1px;
            height: 100%;
            border-left: 1px solid ${props => props.theme.colors.secondary._500};
            padding-right: 5px;
            margin-left: 5px;
          `}
      />
      <span
          css={`
            font-family: Playfair Display, sans-serif;
            color: ${props => props.theme.colors.secondary._500};
          `}
      >imagine</span>
  </>
);